import axios from 'axios';

import { IDigitalValue } from '@/shared/model/digital-value.model';
import { IThreshold } from '@/shared/model/threshold.model';

const baseApiUrl = 'api/digital-values';
const thresholdApiUrl = 'api/threshold-value';

export default class DigitalValueService {
  public find(id: number): Promise<IDigitalValue> {
    return new Promise<IDigitalValue>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IDigitalValue): Promise<IDigitalValue> {
    return new Promise<IDigitalValue>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/${entity.id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public updateThreshold(threshold: IThreshold): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .put(thresholdApiUrl, threshold)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
  public getThreshold(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(thresholdApiUrl)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
